import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import AdsIntro from '../../components/AdsIntro'
import AdsDescription from '../../components/AdsDescription'
import AdsAuthorCard from '../../components/AdsAuthorCard'
import AdsTypes from '../../components/AdsTypes'
import AdsShareSocialNetworks from '../../components/AdsShareSocialNetworks'
import AdsReplacementDate from '../../components/AdsReplacementDate'
import AdsDetails from '../../components/AdsDetails'
import BlockAdsRelated from '../../components/blocks/BlockAdsRelated'
import BannerTitleTextButton from '../../components/BannerTitleTextButton'
import ActionButton from '../../components/ActionButton'
import { mq, sizes } from '../../theme'
import Link from '../../components/Link'
import AdsStatus from '../../components/AdsStatus'
import AdsHighlight from 'src/components/AdsHighlight'

export const Layout = styled(MainLayout)``

export const Backlink = styled(Link)`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratSm};
  display: flex;
  align-items: center;
  gap: 1.2rem;
`

export const Intro = styled(AdsIntro)``

export const Container = styled.div`
  margin-top: -2.5rem;

  @media ${mq(sizes.desktop)} {
    display: flex;
    gap: 3rem;
    justify-content: space-between;
    margin-top: -4rem;
  }
`

export const LeftWrapper = styled.div`
  @media ${mq(sizes.desktop)} {
    max-width: 65.4rem;
    flex: 2;
  }
`

export const RightWrapper = styled.div`
  @media ${mq(null, sizes.desktop)} {
    margin-top: 7.8rem;
  }
  @media ${mq(sizes.desktop)} {
    max-width: 36.5rem;
    flex: 1;
  }
`

export const Description = styled(AdsDescription)``

export const AuthorCard = styled(AdsAuthorCard)``

export const Types = styled(AdsTypes)`
  margin: 2.8rem -2rem 0 -2rem;

  @media ${mq(sizes.desktop)} {
    margin: 2.8rem 0 0;
  }
`

export const Highlight = styled(AdsHighlight)`
  margin: 2.8rem 0 0;
`

export const ShareSocialNetworks = styled(AdsShareSocialNetworks)`
  @media ${mq(sizes.tablet)} {
    margin-top: 2.8rem;
  }
`

export const ReplacementDate = styled(AdsReplacementDate)`
  margin-top: 2rem;

  @media ${mq(null, sizes.mobile)} {
    td {
      padding: 0.8rem;
      span {
        width: 1rem;
        height: 1rem;
      }
    }
  }
`

export const Details = styled(AdsDetails)`
  margin-top: 3rem;
`

export const AnswerAdButton = styled(ActionButton)`
  margin: 3.6rem auto 3.5rem auto;
  display: block;
  width: max-content;
`

export const TitleTextButtonBanner = styled(BannerTitleTextButton)``

export const AdsRelated = styled(BlockAdsRelated)``

export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 2.5rem 2rem;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    justify-content: space-between;
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('scoping')} {
    margin: 2.5rem 6.4rem;
  }
`

export const PreviewBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.down('mobile')} {
    justify-content: center;
  }
`

export const Status = styled(AdsStatus)``

export const PreviewButtons = styled(ActionButton)``
